module.exports = __webpack_public_path__ + "img/cbardhall64_ua.f3b5f9e4.webp";